import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

// --- Build-time env sanity check (visible in console for prod debugging) ---
if (!process.env.REACT_APP_BACKEND_URL) {
  // eslint-disable-next-line no-console
  console.warn(
    '[LoyerBook] REACT_APP_BACKEND_URL is not set. API calls will fail. ' +
    'On Netlify: Site settings → Environment variables → add REACT_APP_BACKEND_URL, then trigger a fresh build (Clear cache and deploy).'
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker();
